<template>
  <div class="row">
    <div class="col d-flex justify-content-center">
      <z-card
        class="login-wrapper"
        title="PASSWORD RECOVERY"
      >
        <div
          v-if="!showConfirmText"
          class="sign-up-text"
        >
          Enter email to reset your password
        </div>
        <form>
          <div
            v-if="!showConfirmText"
            class="row"
          >
            <div class="col-12">
              <z-input-text
                v-model="form.email"
                v-validate.disable="{required: true, email: true}"
                label="YOUR EMAIL"
                name="email"
                :error="errors.first('email')"
                @input="resetValidate"
              />
            </div>
            <div class="col-12 d-flex justify-content-center">
              <z-button
                :loading="loading"
                @click.native="validate"
              >
                Submit
              </z-button>
            </div>
          </div>
          <div
            v-else
            class="text-center"
          >
            {{ message }}

            <div class="mt-3 footer-text">
              Are you not signed up yet?
              <router-link to="/signup">
                sign up
              </router-link>
              or
              <router-link to="/login">
                login
              </router-link>
            </div>
          </div>
        </form>
      </z-card>
    </div>
    <vue-recaptcha
      v-if="recaptchaKey"
      ref="recaptcha"
      size="invisible"
      :sitekey="recaptchaKey"
      :load-recaptcha-script="true"
      @verify="submit"
      @expired="onCaptchaExpired"
    />
  </div>
</template>

<script>
import authAPI from '@/api/auth';
import ZCard from '@/components/shared/ZCard.vue';
import ZButton from '@/components/shared/buttons/ZButton.vue';
import ZInputText from '@/components/shared/input/ZInputText.vue';
import { mapActions } from 'vuex';
import VueRecaptcha from 'vue-recaptcha';

export default {
  components: {
    ZCard,
    ZInputText,
    ZButton,
    VueRecaptcha,
  },

  data: () => ({
    loading: false,
    showConfirmText: false,
    message: '',
    form: {
      email: '',
    },
  }),

  computed: {
    recaptchaKey() {
      return this.$store.getters.recaptchaKey;
    },
  },

  async created() {
    await this.$store.dispatch('authInit');
  },

  methods: {
    ...mapActions({
      setLoading: 'order/SET_LOADING',
    }),

    validate() {
      this.$validator.validateAll().then(async (isValid) => {
        if (isValid) {
          this.$refs.recaptcha.execute();
        }
      });
    },

    resetValidate() {
      this.$validator.reset();
    },

    async submit(recaptchaToken) {
      if (this.loading) return;

      this.loading = true;
      authAPI.forgotPassword({ ...this.form, 'g-recaptcha-response': recaptchaToken })
        .then((response) => {
          if (response.data.success) {
            this.showConfirmText = true;
            this.message = response.data.data.message;
          } else {
            this.$toast.error(response.data.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
  },
};
</script>

<style lang="scss" scoped>
  .login-wrapper {
    margin-top: 60px;
    max-width: 630px;
    width: 100%;
    padding: 50px 50px 20px 50px;
  }

  .sign-up-text {
    text-transform: uppercase;
    text-align: center;
    font-size: 14px;
    font-family: var(--font-medium);
    margin-bottom: 10px;
  }

  .footer-text {
    opacity: 0.7;
    font-size: 14px;

    a {
      color: var(--color-secondary);
    }
  }

  @media screen and (max-width: 991px) {
    .login-wrapper {
      margin-top: 15px;
      padding: 30px 25px 20px 25px;
    }
  }
</style>
